<template>
    <div>
        <ul class="nav nav-tabs">
            <li class="active">
                <a data-toggle="tab"  title="Célibataire / Séparé / Divorcé / Veuf"> {{$t('Bareme.etape1.champs.sectionNonMarie')}}</a></li>
        </ul>
        <div class="row">
            <div class="col-md-6">
                <!--<h4>Célibataire / Séparé / Divorcé / Veuf</h4>-->
                <div class="form-group required" :class="{'has-error': errors.has('isUnionLibre')}">
                    <label class="form-label">{{$t('Bareme.etape1.champs.unionLibre')}}</label>
                    <div class="radio">
                        <label><input type="radio" name="isUnionLibre" v-model="dossier.isUnionLibre" v-validate="'required'"
                                      v-bind:value="true" :aria-label="$t('general.oui')">{{$t('general.oui')}}</label>
                    </div>
                    <div class="radio">
                        <label><input type="radio" name="isUnionLibre" v-model="dossier.isUnionLibre"
                                      v-bind:value="false" :aria-label="$t('general.non')">{{$t('general.non')}}</label>
                    </div>
                    <span v-if="submitted && errors.has('isUnionLibre')" class="text-danger">{{ errors.first('isUnionLibre') }}</span>
                </div>
            </div>

            <div class="col-md-6">
                <div class="form-group required" :class="{'has-error': errors.has('isGardeAlternee')}">
                    <label class="form-label">{{$t('Bareme.etape1.champs.gardeAlternee')}}</label>
                    <div class="radio">
                        <label v-tooltip="{content: getTooltip('Bareme.tooltip.titre.gardeAlternee','Bareme.tooltip.contenu.gardeAlternee'),
                          trigger: 'hover', placement: tooltipPlacement }">
                          <input type="radio" name="isGardeAlternee" v-model="dossier.isGardeAlternee" v-validate="'required'"
                                      v-bind:value="true" :aria-label="$t('general.oui')">{{$t('general.oui')}}</label>
                    </div>
                    <div class="radio">
                        <label v-tooltip="{content: getTooltip('Bareme.tooltip.titre.gardeAlternee','Bareme.tooltip.contenu.gardeAlternee'),
                          trigger: 'hover', placement: tooltipPlacement }">
                          <input type="radio" name="isGardeAlternee" v-model="dossier.isGardeAlternee"
                                      v-bind:value="false" :aria-label="$t('general.non')">{{$t('general.non')}}</label>
                    </div>
                    <span v-if="submitted && errors.has('isGardeAlternee')" class="text-danger">{{ errors.first('isGardeAlternee') }}</span>
                </div>
            </div>
        </div>
        <div class="row">

            <div class="col-md-6">
                <div v-if="dossier.isUnionLibre" class="form-group required">
                    <label class="form-label">{{$t('Bareme.etape1.champs.nbEnfantAChargeUnionPrecendente')}}</label>
                    <select class="form-control" v-model="dossier.nbEnfants" name="nbEnfants" v-validate="'required'">
                        <option value="0">Aucun enfant</option>
                        <option value="1">1 enfant</option>
                        <option value="2">2 enfants</option>
                        <option value="3">3 enfants</option>
                        <option value="4">4 enfants</option>
                        <option value="5">5 enfants</option>
                    </select>
                    <span v-if="submitted && errors.has('datesNaissanceEnfants' + this.dossier.datesNaissanceEnfants[0].id) && !errors.has('nbEnfants')" class="text-danger">
                       {{ errors.firstByRule('datesNaissanceEnfants' + this.dossier.datesNaissanceEnfants[0].id,'ruleNbEnfants', 'agexMax25ALaFinDuMois') }}
                    </span>
                    <span v-if="submitted && errors.has('nbEnfants')" class="text-danger">
                       {{ errors.first('nbEnfants') }}
                    </span>
                </div>
            </div>

            <div class="col-md-6">

            </div>

        </div>
    </div>
</template>

<script>
import TooltipUtils from '../../../utils/TooltipUtils';

export default {
  name: 'section-non-marie',
  props: ['dossier', 'submitted'],
  inject: ['$validator'],
  mixins: [TooltipUtils],
};
</script>

<style scoped>

</style>
